import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 30000
});

// Request interceptor — attach Clerk Bearer token to every request
api.interceptors.request.use(async (config) => {
  try {
    const getToken = window.__clerkGetToken;
    if (getToken) {
      const token = await getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
  } catch (err) {
    console.error('[API] Failed to get Clerk token:', err.message);
  }
  return config;
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn('[API] 401 received — session may be invalid');
    }
    if (error.response?.data) {
      const apiError = new Error(error.response.data.message || 'Request failed');
      apiError.code = error.response.data.error;
      apiError.statusCode = error.response.status;
      apiError.required_version = error.response.data.required_version;
      throw apiError;
    }
    throw error;
  }
);

export default api;
